import { render, staticRenderFns } from "./OctCheckbox.vue?vue&type=template&id=04aef5be&scoped=true&"
import script from "./OctCheckbox.vue?vue&type=script&lang=js&"
export * from "./OctCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./OctCheckbox.vue?vue&type=style&index=0&id=04aef5be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aef5be",
  null
  
)

export default component.exports